import classNames from 'classnames'
import {Text} from 'quickstart/components/content/Text'
import {Section} from 'quickstart/components/layout/Section'
import {Children, type ComponentProps, type ReactNode} from 'react'
import {IS_TEST, logger} from 'tizra'
import S from './styles.module.scss'

const log = logger('SideNav')

interface SideNavProps extends ComponentProps<'div'> {
  heading: ReactNode
}

export const SideNav = ({heading, children, ...props}: SideNavProps) => (
  <div {...props} className={classNames(S['side-nav'], props.className)}>
    <Section as="nav" bleed>
      <Text prose variant="subnavHead">
        {heading}
      </Text>
      <div>
        {Children.map(children, child => (
          <div className={S['side-nav-item']}>{child}</div>
        ))}
      </div>
    </Section>
    <div data-sidenav-content ref={rearrange} />
  </div>
)

function rearrange(target: HTMLElement | null) {
  if (target) {
    if (target.children.length !== 0) {
      log.error('target has children?!')
      return
    }

    const blockDiv = target.closest('.t-quickstart-block')
    if (!blockDiv) {
      // Don't trip on fake refs in storyshots
      log.assert(IS_TEST, "can't find surrounding .t-quickstart-block")
      return
    }

    const stackDiv = blockDiv.closest('.t-stacked')
    if (!stackDiv) {
      log.error("can't find surrounding stack")
      return
    }
    if (stackDiv.firstElementChild !== blockDiv) {
      log.error('must be first block in stack')
      return
    }

    const siblings = Array.from(stackDiv.childNodes).filter(
      node => node !== blockDiv,
    )
    log.debug?.('moving siblings into target')
    siblings.forEach(sib => {
      target.append(sib)
    })
  }
}
